export default __webpack_public_path__ + "static/media/Artboard 2.ecf6e738.png";